import { themes } from '@elparking/components'

export const LINE_HEIGHT = Object.keys(themes.maggie.font.lineHeight)
export const FONT_SIZES = Object.keys(themes.maggie.font.sizes)
export const FONT_WEIGHTS = Object.keys(themes.maggie.font.weights)
export const COLORS = Object.keys(themes.maggie.colors)

export default themes.maggie
